import React, { ReactNode } from 'react';
import { chakra, ContainerProps, VStack } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';

interface SongTabFormWrapperProps extends ContainerProps {
  onSubmit?: () => Promise<void>;
  children: ReactNode;
}

export const SongTabFormWrapper = React.forwardRef<
  HTMLFormElement,
  SongTabFormWrapperProps
>(({ children, onSubmit, ...rest }, ref) => (
  <ContentContainer
    type={ContentContainerType.FORM}
    isViewContent
    pt={6}
    h="inherit"
    {...rest}
  >
    <VStack
      as={chakra.form}
      onSubmit={onSubmit}
      autoComplete="off"
      ref={ref}
      h="inherit"
      justifyContent="space-between"
    >
      {children}
    </VStack>
  </ContentContainer>
));
